'use strict';

exports.__esModule = true;
exports["default"] = wrapActionCreators;

var _redux = require('redux');

function wrapActionCreators(actionCreators) {
  return function (dispatch) {
    return (0, _redux.bindActionCreators)(actionCreators, dispatch);
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/react-redux@4.4.10_react@15.7.0+redux@3.7.2/~/react-redux/lib/utils/wrapActionCreators.js
// module id = 181
// module chunks = 0